import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';

export const AntennaIcon = () => <SettingsInputAntennaIcon />;
